import { HeartPulse } from 'lucide-react'
import { Link } from '@tanstack/react-router'

import { type HomeWidgetDefinition } from '@/lib/home-widgets'
import { AGENT_PERMISSIONS } from '@/lib/permissions'

import { AgentHealthWidget } from './agent-health-widget'

export const agentHomeWidgets = [{
  id: 'agents.health', name: 'Agent health', description: 'The health of agents reporting to this entity.',
  icon: HeartPulse, order: 30,
  defaultSize: { columns: 1, rows: 4 }, minimumSize: { columns: 1, rows: 3 },
  permission: AGENT_PERMISSIONS.read,
  viewAll: ({ entityId, className }) => <Link to="/$entityId/agents" params={{ entityId }} className={className}>View agents</Link>,
  component: AgentHealthWidget,
}] satisfies readonly HomeWidgetDefinition[]
